import { Badge } from '@monksflow/monks-ui';
import { TrendingUpIcon } from 'lucide-react';

import { AnalysisMarkdown, AnalysisSubHeader } from '../../../../components';

import { StatistaChartCard } from '../StatistaCharts';

import type { EmergingTrendsProps } from './EmergingTrends.types';
import { useTranslation } from 'react-i18next';

export const EmergingTrends = ({ emergingTrends, citedDatasets }: EmergingTrendsProps) => {
  const { t } = useTranslation('analysis');

  if (!emergingTrends?.length) return null;

  return (
    <div className="flex flex-col gap-6">
      <AnalysisSubHeader
        title={t('analysisResult.emergingTrends.emergingTrends')}
        subtitle={t('analysisResult.emergingTrends.forcesReshapingTheCompetitiveSet')}
        subtitleTone="meta"
      />

      <div className="grid grid-cols-1 items-stretch gap-sm md:grid-cols-2 lg:grid-cols-3">
        {emergingTrends.map((trend, index) => (
          <div
            key={`${trend}-${index}`}
            className="flex h-full flex-col items-center gap-1 rounded-xl border border-border-light p-xl text-center"
          >
            <Badge
              variant="secondary"
              size="sm"
              roundness="full"
              className="mb-2 dark:bg-surface-raised"
            >
              {t('analysisResult.emergingTrends.trendNumber', { number: index + 1 })}
            </Badge>
            <AnalysisMarkdown text={trend} className="text-body-md text-foreground" />
          </div>
        ))}
      </div>
      {/* Closes the section under the trends it summarises. */}
      <div className="flex flex-col items-start gap-2 rounded-xl bg-violet-50 px-10 py-8 text-left dark:bg-violet-950">
        <span className="flex items-center gap-2 text-body-md font-medium text-foreground-subtle">
          <TrendingUpIcon className="size-[18px] shrink-0" />
          {t('analysisResult.emergingTrends.marketEvolution')}
        </span>
        <span className="max-w-[75ch] text-pretty text-heading-md font-medium -tracking-[0.01em] text-foreground">
          {t('analysisResult.emergingTrends.theseEmergingTrendsAre', {
            count: emergingTrends.length,
          })}
        </span>
      </div>

      {citedDatasets?.map((cited) => (
        <StatistaChartCard key={cited.id} dataset={cited} citedIn={emergingTrends} />
      ))}
    </div>
  );
};
